import React from 'react';
import { ArrowRight, FileText, Printer, CheckSquare } from 'lucide-react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
export function FinalCTA() {
  return <Section id="precio" className="bg-cream text-center pb-24 md:pb-32" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <h2 className="text-3xl md:text-5xl font-bold text-navy mb-8 leading-tight" data-id="element-26">
          ¿Quieres seguir con la duda… <br data-id="element-27" />
          <span className="text-green" data-id="element-28">o prefieres tener una ruta clara?</span>
        </h2>

        <p className="text-xl text-navy/70 mb-10" data-id="element-29">
          Empieza a mejorar el plato de tu perro desde hoy mismo.
        </p>

        <div className="bg-white p-8 rounded-3xl shadow-xl border border-stone-100 mb-10 inline-block w-full max-w-md mx-auto" data-id="element-30">
          <div className="flex justify-center gap-8 mb-8 text-navy/60" data-id="element-31">
            <div className="flex flex-col items-center gap-2" data-id="element-32">
              <FileText className="w-6 h-6 text-green" data-id="element-33" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-34">
                PDF Guía
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-35">
              <Printer className="w-6 h-6 text-green" data-id="element-36" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-37">
                Tablas
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-38">
              <CheckSquare className="w-6 h-6 text-green" data-id="element-39" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-40">
                Checklist
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-41">
            <span className="text-sm text-navy/40 line-through" data-id="element-42">$12.99</span>
            <div className="text-5xl font-bold text-navy mt-1" data-id="element-43">
              $6.29{' '}
              <span className="text-base font-medium text-navy/50" data-id="element-44">USD</span>
            </div>
            <span className="inline-block mt-2 px-3 py-1 bg-amber/10 text-amber rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-45">
              Precio de lanzamiento
            </span>
          </div>

          <Button size="lg" className="w-full text-lg py-8 shadow-green/20 shadow-xl" onClick={() => window.open('https://www.guiakit.com/cart/42522264797271:1', '_blank')} data-id="element-46">
            Quiero la Ruta de 10 Días
            <ArrowRight className="ml-2 h-6 w-6" data-id="element-47" />
          </Button>

          <p className="mt-4 text-xs text-navy/40" data-id="element-48">
            Acceso inmediato · Descarga digital segura
          </p>
        </div>
      </div>
    </Section>;
}